<form *ngIf="destination && initialTranslations">
  <div *ngIf="!editMode || pictureOnly" class="read-only">
    <div *ngFor="let input of initialTranslations | objectToArray">
      <div class="text" *ngIf="input.content">
        <div class="key">
          <span class="lock">
            <md-icon *ngIf="initialTranslations[input.key].isLocked"
              >lock</md-icon
            >
            <md-icon *ngIf="!initialTranslations[input.key].isLocked"
              >lock_open</md-icon
            >
            <p class="magicbox-tooltip">{{ input.magicBoxRule }}</p>
          </span>
          {{ input.name }}
        </div>
        <div class="value">{{ input.content }}</div>
      </div>
    </div>
  </div>

  <div *ngIf="editMode && !pictureOnly">
    <div class="multilingual">
      <button
        type="button"
        md-raised-button
        color="primary"
        (click)="multilingual()"
      >
        <md-icon>language</md-icon>
        Multilingual edition
      </button>
      <span
        [mdTooltip]="
          canScheduleMagicBox ? '' : 'A Magic Box has been already scheduled'
        "
      >
        <button
          [disabled]="!canScheduleMagicBox"
          type="button"
          md-raised-button
          color="primary"
          (click)="scheduleMagicbox()"
        >
          <md-icon>flash_on</md-icon>
          Schedule Magic Box
        </button>
      </span>
    </div>
    <div>
      <div *ngFor="let input of initialTranslations | objectToArray">
        <div *ngIf="input.inputType" class="section">
          <div class="lock" matTooltipHideDelay="2000">
            <md-icon
              *ngIf="destination.value.translations[input.key].isLocked"
              (click)="
                destination.value.translations[input.key].isLocked = false
              "
              >lock</md-icon
            >
            <md-icon
              *ngIf="!destination.value.translations[input.key].isLocked"
              (click)="
                destination.value.translations[input.key].isLocked = true
              "
              >lock_open</md-icon
            >
            <p class="magicbox-tooltip">
              <a
                *ngIf="input.magicBoxRuleId"
                [routerLink]="[
                  '/magicbox/',
                  input.name,
                  input.magicBoxRuleId,
                  !input.magicBoxRuleIsActive
                ]"
                >#{{ input.magicBoxRuleId }}</a
              >
              {{ input.magicBoxRuleExpression }}
              <br /><br />Last Editor: {{ input.lastEditor }}
            </p>
          </div>
          <md-form-field *ngIf="input.inputType === 'Text'">
            <input
              mdInput
              [placeholder]="input.name"
              [name]="input.key"
              [disabled]="
                disablePressField ||
                (disablePartnersField && input.name === 'Title')
              "
              [(ngModel)]="destination.value.translations[input.key].content"
              [maxlength]="input.maxLength"
              (change)="changeValue(destination.value.translations[input.key])"
            />
            <md-hint align="end">
              {{
                (destination.value.translations[input.key].content | toString)
                  .length
              }}
              /
              {{ input.maxLength }}
            </md-hint>
          </md-form-field>
          <div class="tinymce" *ngIf="input.inputType === 'Html'">
            <div class="placeholder">{{ input.name }}</div>
            <app-tinymce-editor
              [elementId]="
                input.key +
                '-' +
                destination.id.replace(' ', '') +
                '-' +
                destination.value.translations[input.key].name
              "
              [toolbar]="false"
              [editMode]="!disablePressField"
              [value]="destination.value.translations[input.key].content"
              [maxLength]="input.maxLength"
              (onEditorKeyup)="
                tinyMceChanged(
                  $event,
                  destination.id,
                  destination.value.translations[input.key]
                )
              "
              (change)="changeValue(destination.value.translations[input.key])"
            >
            </app-tinymce-editor>
            <md-hint align="end">
              {{
                (destination.value.translations[input.key].content | toString)
                  .length
              }}
              /
              {{ input.maxLength }}
            </md-hint>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="!editMode && initialPictures">
    <div class="section center">
      <h4>Pictures</h4>
    </div>
  </div>
  <div *ngIf="initialPictures">
    <div>
      <!-- Edit picture -->
      <div *ngIf="editMode" class="section center">
        <div
          *ngIf="destination.value.pictures[0]"
          class="lock"
          [tooltip]="
            destination.id == 'Popup Next'
              ? 'Lock picture for manual edition'
              : destination.value.pictures[0].magicBoxPictureExpression
          "
        >
          <md-icon
            *ngIf="destination.value.pictures[0].isLocked"
            (click)="lockPictures(destination)"
            >lock</md-icon
          >
          <md-icon
            *ngIf="!destination.value.pictures[0].isLocked"
            (click)="lockPictures(destination)"
            >lock_open</md-icon
          >
        </div>
        <h4>Pictures edition</h4>
      </div>

      <div class="section around" *ngIf="initialPictures">
        <div *ngFor="let picture of filterPictures(destination.value.pictures)">
          <div class="picture">
            <img
              *ngIf="editMode && !disablePartnersField && !disablePressField"
              [src]="picture.pictureURL || picture.blob"
              width="300"
              class="picture-edit"
              (click)="editPicture(picture.pictureFormatName, destination.id)"
            />
            <img
              *ngIf="!editMode || disablePartnersField || disablePressField"
              [src]="picture.pictureURL || picture.blob"
              width="300"
            />
          </div>
        </div>
        <button
          *ngIf="
            filterPictures(destination.value.pictures).length == 0 &&
            editMode &&
            !disablePartnersField
          "
          (click)="editPicture('Original', destination.id)"
          md-raised-button
          color="accent"
        >
          Add pictures
        </button>
      </div>
    </div>
  </div>
  <br />
  <div
    class="toggle-duplicate"
    *ngIf="destination.id == 'Digital' && canDuplicate"
  >
    <md-slide-toggle
      [checked]="isDuplicateToPressOn"
      (change)="duplicateDataPress($event)"
    ></md-slide-toggle>
    Duplicate data for Press
  </div>
  <div
    class="toggle-duplicate"
    *ngIf="destination.id == 'Partners' && canDuplicateToPartners"
  >
    <md-slide-toggle
      [checked]="isDuplicateToPartnersOn"
      (change)="duplicateDataPartners($event)"
    ></md-slide-toggle>
    Duplicate data from Digital
  </div>
  <div class="toggle-duplicate" *ngIf="canDuplicateToInter">
    <md-slide-toggle
      [checked]="isDuplicateToInterOn"
      (change)="duplicateDataInter($event)"
    ></md-slide-toggle>
    Duplicate data for Inter
  </div>
  <div
    class="toggle-duplicate"
    *ngIf="dataDuplicationOnCurrentLanguage == true"
  >
    <div>
      <span>Save informations to others languages</span>
    </div>
    <md-select
      [(ngModel)]="multilingualLanguages"
      [ngModelOptions]="{ standalone: true }"
      md-tooltip="Select languages to apply changes"
      [multiple]="true"
    >
      <md-option
        (click)="clickOnSelectAllMultilingual()"
        [value]="selectAllMultilanguage"
        >Select all
      </md-option>
      <md-option
        (click)="clickOnSelectLanguageMultilingual()"
        *ngFor="let language of availableLanguages | orderBy : 'value'"
        [disabled]="language === currentUser.currentLanguage"
        [value]="language"
      >
        {{ language.value }}
      </md-option>
    </md-select>
  </div>
  <br />
  <div class="section center start">
    <div class="column" tooltip-position="above">
      <button
        *ngIf="editMode"
        type="button"
        md-raised-button
        color="accent"
        (click)="additionalPicturesEmitter()"
      >
        <md-icon>image</md-icon>
        MAX Additional pictures
      </button>
    </div>
    <div class="column" tooltip-position="above">
      <button
        *ngIf="editMode"
        type="button"
        md-raised-button
        color="accent"
        (click)="saveFieldsAction(false)"
        [disabled]="!programModified && multilingualLanguages.length === 1"
      >
        <md-icon>save</md-icon>
        Save this program only
      </button>
      <a
        *ngIf="programArticle.isMultiCam"
        md-button
        class="seeReplays"
        (click)="seeMultiCamsEmitter()"
      >
        See other cams
      </a>
    </div>
    <div
      class="column"
      tooltip-position="above"
      [tooltip]="
        programArticle.spev.id <= 0 &&
        programArticle.contentId === '0' &&
        !programArticle.btSportProductCode &&
        programArticle.programId <= 0
          ? 'Program has no Ids for SaveAllReplays'
          : ''
      "
    >
      <button
        *ngIf="editMode"
        type="button"
        md-raised-button
        color="accent"
        (click)="saveFieldsAction(true)"
        [disabled]="
          (!programModified && multilingualLanguages.length === 1) ||
          (programArticle.spev.id <= 0 &&
            (!programArticle.contentId || programArticle.contentId === '0') &&
            !programArticle.btSportProductCode) ||
          programArticle.channel.id > 20000
        "
      >
        <md-icon>save</md-icon>
        Save all replays
      </button>
      <a
        *ngIf="
          programArticle.spev.id > 0 ||
          (programArticle.contentId && programArticle.contentId !== '0') ||
          programArticle.btSportProductCode
        "
        md-button
        class="seeReplays"
        (click)="seeReplaysEmitter()"
      >
        See replays
      </a>
    </div>
  </div>
</form>



// WEBPACK FOOTER //
// ./src/app/components/program-article-form/program-article-form.component.html